/*
 * @Author: Dong
 * @Date: 2022-04-20 11:14:22
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-06-24 15:08:43
 */
import { GET_LOG_RECORD, SET_LODING } from '../constant';
import { syncBackStatus } from './types';

const defaultStates: syncBackStatus = {
  dataSource: [],
  pagination: {
    current: 1,
    total: 1,
    pageSize: 20,
  },
  logListLoading: true,
};

const syncBack = (state = { ...defaultStates }, action: any) => {
  const { type, payload } = action;
  switch (type) {
    // 获取日志记录
    case GET_LOG_RECORD: {
      const { resultList, current, total, pageSize } = payload;

      return {
        ...state,
        dataSource: resultList,
        pagination: {
          current: current,
          total,
          pageSize,
        },
        logListLoading: false,
      };
    }
    // 设置loding
    case SET_LODING: {
      return {
        ...state,
        logListLoading: payload,
      };
    }
    default:
      return state;
  }
};

export default syncBack;
